export default __webpack_public_path__ + "static/media/saa.5de5ac50.png";